// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cB","header":"cC","button":"cD","confirmationBox":"cE","details":"cF","detail":"cG","detailLabel":"cH","detailImage":"cI"};